import {
    Component,
    Input,
    ElementRef,
    AfterViewInit,
    AfterContentInit,
    OnChanges,
    AfterViewChecked
} from '@angular/core';
import {iRoute, iRouteWaypoint, iRouteCordinate, iRouteSlides} from '../service/routes';
declare var jQuery: any;

@Component({
    selector: 'slick-slider',
    template: `
        <!-- carousel item -->
        <div class="carousel-slider-item" *ngFor="let slide of slides">
            <a class="highlight-item" [href]="slide.link" target="_blank">
                <figure>
                    <img class="carousel-slider-image" [src]="slide.img" alt="Alternative Text"/>

                    <figcaption>
                        <!-- overlay -->
                        <div class="highlight-overlay">
                            <div class="overlay-bg"></div>
                            <div class="overlay-text-wrapper">
                                <h3 class="overlay-headline">{{slide.title}}</h3>
                            </div>
                            <div class="overlay-sub-text-wrapper">
                                <h3 class="overlay-sub-headline">{{slide.subtitle}}
                                    <span class="fa fa-arrow-right" aria-hidden="true"></span>
                                </h3>
                            </div>
                        </div><!-- ./overlay -->
                    </figcaption>
                </figure>
            </a>
        </div>
        <!-- ./carousel item -->
    `
})
export class SlickSliderComponent implements AfterContentInit, OnChanges, AfterViewChecked {
    @Input() slides: Array<iRouteSlides>;

    private changed = false;
    $element: any;

    defaultOptions: any = {
        dots: true,
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        speed: 200,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 550,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 421,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    constructor(private el: ElementRef) {
    }

    ngAfterContentInit() {
        this.$element = jQuery(this.el.nativeElement);
        this.$element.slick(this.defaultOptions);
        console.log("ngAfterContentInit");
    }

    ngOnChanges(changes) {
        console.log(changes);
        this.changed = true;
    }

    ngAfterViewChecked() {
        if (this.changed && this.$element) {
            console.log("slick reinit start: %o", this.$element);
            // we have to remove them like this, because angular can anymore wiht its ngFor
            this.$element.slick('removeSlide', null, null, true);
            // destroy the slider and recreate it
            this.$element.slick("unslick");
            this.$element.slick(this.defaultOptions);
            console.log("slick reinit end");
            this.changed = false;
        }

    }
}


// WEBPACK FOOTER //
// ./assets_dev/ts/app/component/slick-slider.component.ts